import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    signupModalOpen: false,
    profileModalOpen: false,
    settingsModalOpen: false,
    closeOutNotesModalOpen: false,
    feedbackModalOpenByWorkOrder: {},
  },
};

const modalsManagementSlice = createSlice({
  name: "modalsManagementSlice",
  initialState,
  reducers: {
    setSignupModalOpen: (state, action) => {
      state.value.signupModalOpen = action.payload;
    },
    setProfileModalOpen: (state, action) => {
      state.value.profileModalOpen = action.payload;
    },
    setSettingsModalOpen: (state, action) => {
      state.value.settingsModalOpen = action.payload;
    },
    setFeedbackModalOpen: (state, action) => {
      const { workOrderId, isOpen } = action.payload;
      state.value.feedbackModalOpenByWorkOrder[workOrderId] = isOpen;
    },

    setAllModalsClose: (state) => {
      state.value = {
        signupModalOpen: false,
        profileModalOpen: false,
        settingsModalOpen: false,
        closeOutNotesModalOpen: false,
        feedbackModalOpenByWorkOrder: {}
      };
    },
  },
});

export const {
  setSignupModalOpen,
  setProfileModalOpen,
  setSettingsModalOpen,
  setFeedbackModalOpen,
  setAllModalsClose,
} = modalsManagementSlice.actions;

export default modalsManagementSlice.reducer;
